import React, { useState ,useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import * as Yup from "yup";
import { Row, Col, Table } from "react-bootstrap";
import InputField from "../InputField/InputField";
import SlectInputField from "../SlectInputField/SlectInputField";
import TextareaField from "../TextareaField/TextareaField";
import { Formik, Field } from "formik";
import CustomDateTimePicker from '../InputField/CustomDateTimePicker';
import * as AuthVerify from '../../lib/common';
import { Flip, Slide, toast } from 'react-toastify';
import Axios from '../../lib/axios/axiosInstance';
import ReCAPTCHA from "react-google-recaptcha";
import './SendUsMessage.style.css';
import * as Constant from '../../lib/constant';

const CorporateformSchema = Yup.object().shape({
  type: Yup.string().required("Type is required"),
  subject: Yup.string().required("Subject is required"),
  email: Yup.string().email("Email is invalid").required("Email is required"),
  body: Yup.string().required("Message is required"),
  ptc: Yup.string().required("Contact Person is required"),
  company: Yup.string().required("Company is required"),
  phone: Yup.string().required("Contact No is required")
});

const Helpdesk = () => {
  const grecaptchaObject = window.grecaptcha;
  const [acccountDetails, setacccountDetails] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [dob, setDob] = useState(null);
  const recaptchaRef = useRef(null)
  const [initialValue, setInitialValue] = useState({
    type: "",
    subject: "",
    body: "",
    ptc: "",
    phone: "",
    company: "",
    email: "",
  });

  const updateFormSubmitHandler = async (values,resetForm) => {
    if(!captchaVerified){
      toast.error('Captcha not verified !', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 4000,
        transition: Slide,
      });
      return;
    }
    var val = {
      message:values,
      captcha:captchaVerified
    }
    // Send Us Message
    // https://devb2b.bizpoint-intl.com:3082/api/contact/message/
    await Axios.post('/contact/message/',val)
    .then(async (response) =>{
      if (response && response.status == 200 && response.data.data?.msg?.uuid) {
        toast.success('Message sended successfully !', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 4000,
          transition: Slide,
        });
        resetForm();
      }
      else {
        toast.error('Something went Wrong!', {
          position: toast.POSITION.TOP_CENTER,
          autoClose: 3000,
          transition: Flip,
        })
      }
    });
  };

  function onReCAPTCHAChange(value) {
    // AuthVerify.recaptchaVerify(value)
    // .then(result=>{
    //   if(result)setCaptchaVerified(true);
    //   else setCaptchaVerified(false);
    // })
    // .catch(error=>{
    //   console.log(error)
    // })
    setCaptchaVerified(value)
  }

  return (
    <>
    <div className="container">
    <br />
    <div id="accordion">
    <div className="page-content checkout-page">
            <div className="box-border customSendUsMessageDiv">
              <Formik
                initialValues={initialValue}
                validationSchema={CorporateformSchema}
                onSubmit={(values, { setSubmitting,resetForm  }) => {
                  // console.log(values);
                  updateFormSubmitHandler(values,resetForm);
                  setSubmitting(false);
                }}
                enableReinitialize
              >
                {({
                  values,
                  errors,
                  touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                  setFieldValue,
                }) => (
                  <form onSubmit={handleSubmit}>
                    <Col xl={12} sm={12} xs={12}>
                        <Row>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Type</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <SlectInputField
                                    Name="type"
                                    placeHolder="Select Type"
                                    options={[
                                      { label: "Enquiries", value:  "Enquiries"},
                                      { label: "Feedback", value:  "Feedback"},
                                      { label: "Compliment", value:  "Compliment"}
                                    ]}
                                    value={values.type}
                                    onChange={e=>{handleChange(e); }}
                                    onBlur={handleBlur}
                                    className={
                                      (errors.type && touched.type
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                </Col>
                              </Row>   
                            </Col>
                            <br/>
                            <br/>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Subject</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <InputField
                                    Name="subject"
                                    id="subject"
                                    Type="text"
                                    value={values.subject}
                                    onChange={handleChange}
                                    isInvalid={!!errors.subject}
                                    className={(errors.subject && touched.subject) ? 'is-invalid' : 'form-control'}
                                  />
                                </Col>
                              </Row>   
                            </Col>

                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Message</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <TextareaField
                                    Rows={15}
                                    Name="body"
                                    id="body"
                                    Type="text"
                                    value={values.body}
                                    onChange={handleChange}
                                    isInvalid={!!errors.body}
                                    className={(errors.body && touched.body) ? 'is-invalid customTextArea' : 'form-control customTextArea'}
                                  />
                                </Col>
                              </Row>   
                            </Col>

                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Contact Person</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <InputField
                                    Name="ptc"
                                    id="ptc"
                                    Type="text"
                                    value={values.ptc}
                                    onChange={handleChange}
                                    isInvalid={!!errors.ptc}
                                    className={(errors.ptc && touched.ptc) ? 'is-invalid' : 'form-control'}
                                  />
                                </Col>
                              </Row>   
                            </Col>

                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Contact No</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <InputField
                                    Name="phone"
                                    id="phone"
                                    Type="text"
                                    value={values.phone}
                                    onChange={handleChange}
                                    isInvalid={!!errors.phone}
                                    className={(errors.phone && touched.phone) ? 'is-invalid' : 'form-control'}
                                  />
                                </Col>
                              </Row>   
                            </Col>

                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Company Name</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <InputField
                                    Name="company"
                                    id="company"
                                    Type="text"
                                    value={values.company}
                                    onChange={handleChange}
                                    isInvalid={!!errors.company}
                                    className={(errors.company && touched.company) ? 'is-invalid' : 'form-control'}
                                  />
                                </Col>
                              </Row>   
                            </Col>

                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Email Address</Col>
                                <Col xl={8} sm={8} md={8}>
                                  <InputField
                                    Name="email"
                                    id="email"
                                    Type="email"
                                    value={values.email}
                                    onChange={handleChange}
                                    isInvalid={!!errors.email}
                                    className={(errors.email && touched.email) ? 'is-invalid' : 'form-control'}
                                  />
                                </Col>
                              </Row>   
                            </Col>
                            <br/>
                            <Col xl={12} sm={12} md={12}>
                              <Row>
                                <Col xl={4} sm={4} md={4}>Re-CAPTCHA</Col>
                                <Col xl={8} sm={8} md={8}>
                                <ReCAPTCHA
                                  ref={recaptchaRef}
                                  sitekey={Constant.ReCAPTCHA_SITE_KEY}
                                  grecaptcha={grecaptchaObject}
                                  // size='invisible'
                                  onChange={onReCAPTCHAChange}
                                />
                                </Col>
                              </Row>   
                            </Col>

                          </Row>
                        </Col>

                    <Col xl={12} sm={12} xs={12}>
                      <Row>
                        
                        <Col xl={12} sm={12}>
                          <button type="submit" className="button" style={{float:"right"}}>
                            Send Message
                          </button>
                        </Col>
                      </Row>
                    </Col>
                  </form>
                )}
              </Formik>
            </div>
          </div>
      </div>
  </div>
    <br />
    <br />
    </>
  );
};

export default Helpdesk;
